import { BaseModel } from "@blue-chip/core";
import Contact from "./Contact";
import AddressBook from "./AddressBook";

export default class AddressBookContact extends BaseModel {
  static get belongsTo() {
    return [AddressBook, Contact];
  }
}
